import Api from "../constants/api";
import dispatcher from "../dispatchers/dispatcher";
import BASEURL from "../../config";

let URL = `https://script.google.com/macros/s/AKfycbw1BPesnI0RiT8JdJd7hXGDPS3G02n-HeZw1hKrKQVkP_YtmIaR_wHpR97-aROjW702/exec`;
if (process.env.NODE_ENV === "production" && BASEURL === "https://api-v2.happay.in/") {
    URL = `https://script.google.com/macros/s/AKfycbxira0Sn-7ix4GHmVIu6inDzLl9aYn8j_xSs0vHbxLrc_YcZtQJ6wb20HxOahqey2_7KA/exec`;
}

export const getSurveyData = (query, onlyFetch) => {
    Api._callApiWithoutBaseURL(URL, "GET", query, (type, dt) => {
        if (type === "success") {
            // console.log(10, "NPS-Feedback", dt?.res_data, onlyFetch);
            if (dt.res_data && Object.keys(dt.res_data).length) {
                dispatcher.dispatch({
                    type: "GET_FEEDBACK_SURVEY_DATA",
                    response: dt.res_data,
                    onlyFetch
                });
            }
        }
    });
};

export const postSurveyData = (query) => {
    const tempURL = `${URL}?action=submitFeedback`;
    Api._callApiWithoutBaseURL(tempURL, "POST", query, (type, dt) => {
        if (type === "success") {
            if (dt.res_data && Object.keys(dt.res_data).length) {
                dispatcher.dispatch({
                    type: "SUBMIT_FEEDBACK_SURVEY",
                    response: dt.res_data
                });
            }
        }
    });
}